import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Buildings14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_43)'>
      <path d='M11 4.75H8V3.25H11V4.75Z' fill='currentColor' />
      <path d='M11 7.75H8V6.25H11V7.75Z' fill='currentColor' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.25 1.5C5.25 0.809645 5.80964 0.25 6.5 0.25H12.5C13.1904 0.25 13.75 0.809644 13.75 1.5V12.5C13.75 13.1904 13.1904 13.75 12.5 13.75H1.5C0.809644 13.75 0.25 13.1904 0.25 12.5V6.5C0.25 5.80964 0.809644 5.25 1.5 5.25H5.25V1.5ZM5.25 6.75H1.75V12.25H5.25V6.75ZM6.75 12.25H8.75V10H10.25V12.25H12.25V1.75H6.75V12.25Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_43'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Buildings14.displayName = 'Buildings14';
export default Buildings14;
